<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
const { hasSeenCompleteRegModal } = useRegistrationState();

const site = useSiteStore();

const handleContinue = () => {
  site.deactivateModal();
  site.activateModal('complete-registration');
};

onMounted(() => {
  if (hasSeenCompleteRegModal.value) site.deactivateModal();
});
onBeforeUnmount(() => handleContinue());
</script>

<template>
  <div>
    <div class="flex flex-col gap-2 p-4">
      <span class="text-base-priority">
        {{ $t('complete-registration-modal-body') }}
      </span>
    </div>
    <div class="w-full p-4 bg-base">
      <div class="flex gap-4">
        <Button
          element-name="step-one-next-registration"
          type="primary"
          class="w-full justify-center"
          @click="handleContinue"
        >
          {{ $t('continue') }}
        </Button>
      </div>
    </div>
  </div>
</template>
